import { FilterDropdown, FilterInput } from 'components/tailwind-ui/FilterDropdown';
import * as React from 'react';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { SHIPMENTS_QUERY_PARAMS } from 'pages/Shipments/params';
import { Members } from './Members';

export const DeletedBy: React.FC = () => {
  const { searchParams, setSearchParams } = useCustomSearchParams(SHIPMENTS_QUERY_PARAMS);
  const { deletedBy } = searchParams;
  const [search, setSearch] = React.useState<string>('');

  return (
    <FilterDropdown label="Deleted by">
      <FilterInput value={search} setValue={setSearch} placeholder="Filter by user" />
      <Members
        selected={deletedBy}
        setSelected={(emails) => setSearchParams({ deletedBy: emails })}
        search={search}
      />
    </FilterDropdown>
  );
};
DeletedBy.displayName = 'Shipments.DeletedContainers.ActionBar.DeletedBy';
